/* global document, window, process */
export const initializeGoogleAnalytics = () => {
  const GA_MEASUREMENT_ID = "G-QXZ8PGJTGT";

  if (document.getElementById("ga-gtag")) {
    return;
  }

  const gtagScript = document.createElement("script");
  gtagScript.id = "ga-gtag";
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement("script");
  inlineScript.id = "ga-gtag-inline";
  inlineScript.textContent =
    "window.dataLayer = window.dataLayer || [];" +
    "function gtag(){window.dataLayer.push(arguments);}" +
    "gtag('js', new Date());" +
    `gtag('config', '${GA_MEASUREMENT_ID}');`;
  document.head.appendChild(inlineScript);
};

export const initializeHyros = () => {
  if (document.getElementById("hyros-script")) {
    return;
  }

  const script = document.createElement("script");
  script.id = "hyros-script";
  script.type = "text/javascript";
  script.src =
    "https://t.legalassistant.au/v1/lst/universal-script?ph=f4f2ae5a8ceda1364510f741005bf83ddc58586fb68ed1be4ba6827a312bb249&tag=!clicked&ref_url=" +
    encodeURI(document.URL);
  document.head.appendChild(script);
};

export const initializeLinkedIn = () => {
  if (document.getElementById("linkedin-script")) {
    return;
  }

  const script = document.createElement("script");
  script.id = "linkedin-script";
  script.type = "text/javascript";
  script.textContent = `
    _linkedin_partner_id = "6462676";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    (function(l) {
    if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
    window.lintrk.q=[]}
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);})(window.lintrk);
  `;
  document.head.appendChild(script);
};

export const initializeMetaPixel = () => {
  if (document.getElementById("meta-pixel-script")) {
    return;
  }

  const script = document.createElement("script");
  script.id = "meta-pixel-script";
  script.textContent = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '399763346233609');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
};

export const initializeTracking = () => {
  if (process.env.APP_ENV !== "production") {
    console.log("Tracking disabled in development environment");
    return;
  }

  initializeGoogleAnalytics();
  initializeHyros();
  initializeLinkedIn();
  initializeMetaPixel();
};
